const selectors = {
    container: '[data-product-gift]',
    options: '.product-option'
}

const productOptionsClasses = {
    checked: 'product-option__checked'
}

class ProductOptions extends HTMLElement {
    constructor() {
        super();

        this.container = document.querySelector(selectors.container);
        this.options = [...this.container.querySelectorAll(selectors.options)];

        this.registerEventListeners();

        this.getVariantOnLoad();
    }

    getVariantOnLoad() {
        const searchParams = (new URL(document.location)).searchParams;
        const variant = searchParams.get('variant');

        if(variant === null) {
            return;
        }

        this.options.forEach(option => {
            // Reset all checked options;
            option.removeAttribute('checked');
            option.parentElement.parentElement.classList.remove(productOptionsClasses.checked);

            if(option.value === searchParams.get('variant')) {
                option.parentElement.parentElement.classList.add(productOptionsClasses.checked);
                option.setAttribute('checked', 'checked')
            }
        })
    }

    registerEventListeners() {
        this.options.forEach(option => {
            option.addEventListener('change', (e) => {
                if(option.value === e.target.value) {
                    option.dispatchEvent(
                        new CustomEvent('option:update', {
                            bubbles: true,
                            detail: {
                               option: option.value
                            }
                        })
                    );
                }
            })
        });

        document.addEventListener('option:update', (e) => {
            const searchParams = new URLSearchParams();

            searchParams.set('variant', e.detail.option);
            const newurl = `${window.location.protocol}//${
                    window.location.host
                }${window.location.pathname}?${searchParams.toString()}`;
                window.history.pushState({ path: newurl }, '', newurl);

            this.options.forEach(option => {
                // Reset all checked options;

                option.removeAttribute('checked');
                option.parentElement.parentElement.classList.remove(productOptionsClasses.checked);

                if(option.value === searchParams.get('variant')) {
                    option.parentElement.parentElement.classList.add(productOptionsClasses.checked);
                    option.setAttribute('checked', 'checked')
                }
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    customElements.define('product-options', ProductOptions);
});
